export default __webpack_public_path__ + "static/media/what-you-get.fa237bf7.png";